module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/header/header.component.scss
// module id = ./src/app/layout/header/header.component.scss
// module chunks = main